import { ChangeEventHandler, forwardRef, Ref } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { styled } from 'styled-system/jsx';
import { radioButton } from '@/common/components/base/input/radioButton/radioButton.recipe.ts';
import { RadioButtonType } from '@/common/components/base/input/radioButton/RadioButton.type.ts';
import Typography from '@/common/components/base/typography/Typography.tsx';

const RadioButton = (
  props: RadioButtonType,
  ref: Ref<HTMLInputElement> | undefined,
) => {
  const {
    typographyClassName,
    label,
    name,
    value,
    onChange,
    rules,
    disabled = false,
    ...radioButtonProps
  } = props;

  const { control } = useFormContext();
  const { field } = useController({
    control,
    name,
    rules,
  });

  const radioButtonVariants = radioButton({
    checked: field.value === value,
    disabled: disabled,
  });

  const inputOnChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    field.onChange(value);

    onChange?.(e.target.value, value);
  };
  return (
    <styled.div display="flex" alignItems="center" gap="2">
      <styled.input
        type="radio"
        name={name}
        id={`${name}-${value}`}
        ref={ref}
        className={radioButtonVariants}
        checked={field.value === value}
        onChange={inputOnChange}
        disabled={disabled}
        {...radioButtonProps}
      />
      {label && (
        <label htmlFor={`${name}-${value}`}>
          <Typography mr="4px" className={typographyClassName}>
            {label}
          </Typography>
        </label>
      )}
    </styled.div>
  );
};

export default forwardRef(RadioButton);
